import type { Params } from 'react-router';
import { isRouteErrorResponse } from 'react-router';
import { findRESTAPIError } from '@gonfalon/errors/findRESTAPIError';
import { trackError } from '@gonfalon/telemetry/trackError';
import type { RUMCustomErrorContext } from '@gonfalon/telemetry/types';

import { getHTTPStatusSeverity } from './getHTTPStatusSeverity';
import { requestUsesRouteParam } from './internal/requestUsesRouteParam';
import { wrapRouteError } from './internal/wrapRouteError';

type TrackRouteErrorOptions = {
  routeParams?: Params;
};

export function trackRouteError(
  error: unknown,
  context: RUMCustomErrorContext = {},
  { routeParams = {} }: TrackRouteErrorOptions = {},
) {
  if (!error) {
    return;
  }

  const routeErrorContext: RUMCustomErrorContext = { ...context };
  const restAPIError = findRESTAPIError(error);

  if (restAPIError) {
    routeErrorContext.url = restAPIError.url;
    routeErrorContext.metadata = {
      ...routeErrorContext.metadata,
      status: restAPIError.status,
      code: restAPIError.code,
      url: restAPIError.url,
    };

    const isRateLimited = restAPIError.status === 429;
    const isStaleRouteParam = restAPIError.status === 404 && requestUsesRouteParam(restAPIError.url, routeParams);

    if (isRateLimited || isStaleRouteParam) {
      routeErrorContext.severity = 'low';
    } else if (!routeErrorContext.severity) {
      routeErrorContext.severity = getHTTPStatusSeverity(restAPIError.status);
    }
  } else if (isRouteErrorResponse(error)) {
    if (error.status === 429) {
      routeErrorContext.severity = 'low';
    } else if (!routeErrorContext.severity) {
      routeErrorContext.severity = getHTTPStatusSeverity(error.status);
    }
  }

  trackError(wrapRouteError(error), { ...routeErrorContext, severity: routeErrorContext.severity ?? 'high' });
}
